/**
 * 模拟接口假数据
 */

// 登录接口
export function login() {
    let json = {
        token: "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjMyMTdjMGE2LWY5NzMtNDFlNS1hZDkxLWU0Yzc1MjhkNTdkMiJ9.fCH5QQliDJmZfnMh69AQFqV34-zbB7-QAmSpWS9TvD8ieg0X1qlGsHAUM8PykeWxNSB7iM2QlRTqsAxc3SRPTw"
    }
    return new Promise(resolve => {
        setTimeout(_ => {
            resolve({ ...json })
        }, 1500)
    })
}

// 获取用户信息接口
export function getInfo() {
    let json = {
        "msg": "操作成功",
        "code": 200,
        "permissions": [
            "*:*:*"
        ],
        "roles": [
            "admin"
        ],
        "isDefaultModifyPwd": false,
        "isPasswordExpired": false,
        "user": {
            "createBy": "admin",
            "createTime": "2026-01-18 10:58:15",
            "updateBy": null,
            "updateTime": null,
            "remark": "管理员",
            "userId": 1,
            "deptId": 103,
            "userName": "admin",
            "nickName": "若依",
            "email": "ry@163.com",
            "phonenumber": "15888888888",
            "sex": "1",
            "avatar": "",
            "status": "0",
            "delFlag": "0",
            "loginIp": "58.250.251.7",
            "loginDate": "2026-03-20T16:10:21.000+08:00",
            "pwdUpdateDate": "2026-01-18T10:58:15.000+08:00",
            "dept": {
                "createBy": null,
                "createTime": null,
                "updateBy": null,
                "updateTime": null,
                "remark": null,
                "deptId": 103,
                "parentId": 101,
                "ancestors": "0,100,101",
                "deptName": "研发部门",
                "orderNum": 1,
                "leader": "若依",
                "phone": null,
                "email": null,
                "status": "0",
                "delFlag": null,
                "parentName": null,
                "children": []
            },
            "roles": [
                {
                    "createBy": null,
                    "createTime": null,
                    "updateBy": null,
                    "updateTime": null,
                    "remark": null,
                    "roleId": 1,
                    "roleName": "超级管理员",
                    "roleKey": "admin",
                    "roleSort": 1,
                    "dataScope": "1",
                    "menuCheckStrictly": false,
                    "deptCheckStrictly": false,
                    "status": "0",
                    "delFlag": null,
                    "flag": false,
                    "menuIds": null,
                    "deptIds": null,
                    "permissions": null,
                    "admin": true
                }
            ],
            "roleIds": null,
            "postIds": null,
            "roleId": null,
            "admin": true
        }
    }
    return new Promise(resolve => {
        resolve({ ...json })
    })
}

